/* SearchHeadingWithAtlassianApps.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { H3 } from '@atlassian/mpac-primitives';
import React from 'react';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _3 = "._vwz4ahaf{line-height:2.25rem}";
const _2 = "._k48p1fw0{font-weight:700}";
const _ = "._1moujyj9{margin-block:0 .5rem}";
const HeadingStyle = null;
const toCapitalCase = str => str.charAt(0).toUpperCase() + str.slice(1);
const SearchHeadingWithAtlassianApps = _ref => {
  let {
    productName
  } = _ref;
  const headingText = productName ? "Apps for ".concat(toCapitalCase(productName)) : 'Apps';
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(H3, {
      as: "h1",
      className: ax(["_1moujyj9 _k48p1fw0 _vwz4ahaf"]),
      children: headingText
    })]
  });
};
export default SearchHeadingWithAtlassianApps;